import { InfoCircle } from 'iconoir-react';

import { NotOpenForClaimsReason } from '@savgroup-front-common/types/Claim';

import { getNotOpenForClaimsReasonMessage } from './helpers/getNotOpenForClaimsReasonMessage';
import { $NotOpenForClaimsReasonMessage } from './NotOpenForClaimsReasonMessage.styles';

export const NotOpenForClaimsReasonMessage = ({
  notOpenForClaimsReason,
}: {
  notOpenForClaimsReason: NotOpenForClaimsReason;
}) => {
  const reasonMessage = getNotOpenForClaimsReasonMessage(
    notOpenForClaimsReason,
  );

  return (
    <$NotOpenForClaimsReasonMessage>
      <InfoCircle width={16} height={16} />
      {reasonMessage}
    </$NotOpenForClaimsReasonMessage>
  );
};
